export default {
  state: {
    selectedChannelId: '',
    selectedSubbrandInfo: {},
    editFlow: false,
    showHeaderMenu: true,
    showHeaderText: true,
    userInfo: {},
    utid: '',
    rtid: '',
    toastMessage: {
      show: false,
      message: '',
      timeout: 3000,
      color: 'info'
    },
    sessionManagement: {
      beginSessionTimer: false,
      resetSession: false
    },
    isAdmin: false,
    isNewDesign: false,
    activeMainNav: 'setup'
  },
  mutations: {},

  actions: {}
}